import { Box } from "@mui/material";
import { InputButton } from "components/UI";
import React from "react";
import { useSelector } from "react-redux";
import { BUTTON_VALUE, WEB_FUNCTION_ID } from "shared/constants";
import { useLoadingContext } from "shared/contexts/LoadingContext";
import { useUploadRPkgContUploadContMutation } from "shared/services/main-server";
import { responseErrors, responseSuccess } from "utils";

export default function ButtonUploadContainer({
  form,
  setForm,
  setMsg: { setMsgError, setMsgAlert },
  setAppId,
  functionId,
}) {
  const userInfo = useSelector(state => state.auth.user);
  const upload = useUploadRPkgContUploadContMutation();
  const { startLoading, stopLoading } = useLoadingContext();
  const handleUpload = async () => {
    try {
      setMsgAlert([]);
      setMsgError([]);

      const uploadData = new FormData();
      uploadData.append("userCompany", userInfo.companyAbbr);
      uploadData.append("functionId", WEB_FUNCTION_ID.CONTAINER_UPDATE);
      uploadData.append("userId", userInfo.userName);
      uploadData.append("moduleId", "DN93");
      uploadData.append("file", form.file);
      startLoading();
      const response = await upload(uploadData);
      stopLoading();
      setForm({ file: "", fileName: "" });
      const msg = responseSuccess(response);
      setMsgAlert([msg]);
      setAppId(response?.appId);
      return true;
    } catch (error) {
      stopLoading();
      const msgError = responseErrors(error);
      setMsgError(msgError);
      setForm({ file: "", fileName: "" });
      window.scrollTo(0, 0);
      return false;
    }
  };
  return (
    <Box>
      <InputButton
        id="button-upload-container"
        value={BUTTON_VALUE.UPLOAD}
        onClick={handleUpload}
        onKeyDown={e => {
          if (e.key === "Tab") {
            e.preventDefault();
            document.getElementById("input-upload-excel-r-pkg").focus();
          }
        }}
        name={`${functionId}Upload`}
        tabIndex={1}
      />
    </Box>
  );
}
